import GameGenerator from "./GameGenerator"
import Game from "../Model/Game"
import RandomNumberGenerator from "./RandomNumberGenerator"

export default class GameProvider {
  private cache: Record<string, Game> = {}
  constructor(
    private readonly gameGenerator: GameGenerator,
    private readonly randomNumberGenerator: RandomNumberGenerator,
  ) {}

  public getGame(seed: string | undefined = undefined): Game {
    if (seed !== undefined) {
      this.randomNumberGenerator.seed = seed
    }
    this.cache[this.randomNumberGenerator.seed] = this.gameGenerator.generate()

    return this.cache[this.randomNumberGenerator.seed]
  }

  public set(game: Game): void {
    this.cache[this.randomNumberGenerator.seed] = game
  }
}
